var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({staticStyle:{"width":"100%"},attrs:{"value":_vm.myValue,"placeholder":"请选择"}},'el-select',_vm.myAttrs,false),_vm.myListeners),_vm._l((_vm.items),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":_vm.type === 'int' ? (item.code) : item.code}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }